import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { Input } from "../../../../../forms/FormGrid";
import CheckboxWithError from "../../../../../inputs/CheckboxWithError";
import { Subtitle } from "../../../../../layout/AppLayout/ModalDialog/ModalTitle";

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const Label = styled.p`
  color: white;
`;

export const SubTitle = ({ label, showUseTaxPayment }) => {
  const useTaxPaymentInput = {
    name: "useTaxPayment",
    InputComponent: CheckboxWithError,
    label: <Label>Use Tax Payment</Label>,
    ignoreCaption: true,
    style: {
      color: "white",
    },
  };
  const otherInput = {
    name: "other",
    InputComponent: CheckboxWithError,
    label: <Label>Other</Label>,
    ignoreCaption: true,
    style: {
      color: "white",
    },
  };

  return (
    <Wrapper>
      <Subtitle>{label}</Subtitle>
      {showUseTaxPayment && <Input input={useTaxPaymentInput} />}
      <Input input={otherInput} />
    </Wrapper>
  );
};

SubTitle.propTypes = {
  label: PropTypes.string,
  showUseTaxPayment: PropTypes.bool,
};

SubTitle.defaultProps = {
  label: "Cashflow Funding",
  showUseTaxPayment: true,
};
